import { DirectUpload } from "@rails/activestorage";

// Upload a chosen video file for a bout row. Mirrors clip_recorder.js:
// direct-upload the file to Active Storage, then submit the hidden form with
// the returned signed_id. The hidden form always carries the 18+/rights
// attestation so the controller can stamp it on first upload.
const uploadFile = (file, url, onProgress) =>
  new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, url, {
      directUploadWillStoreFileWithXHR(xhr) {
        xhr.upload.addEventListener("progress", (event) => {
          if (!event.lengthComputable || !onProgress) return;
          onProgress(Math.round((event.loaded / event.total) * 100));
        });
      },
    });

    upload.create((error, blob) => {
      if (error) reject(error);
      else resolve(blob.signed_id);
    });
  });

const initClipUploads = () => {
  document.querySelectorAll("[data-clip-upload]").forEach((root) => {
    if (root.dataset.clipUploadBound === "1") return;
    root.dataset.clipUploadBound = "1";

    const uploadUrl = root.dataset.uploadUrl;
    const form = root.querySelector("form");
    const fileInput = root.querySelector("[data-clip-upload-file]");
    const attestation = root.querySelector("[data-clip-upload-attestation]");
    const startBtn = root.querySelector("[data-clip-upload-start]");
    const progressEl = root.querySelector("[data-clip-upload-progress]");
    const statusEl = root.querySelector("[data-clip-upload-status]");
    const videoField = form && form.querySelector("input[name='bout_clip[video]']");

    if (!form || !videoField) return;

    let uploading = false;

    const setStatus = (message, isError = false) => {
      if (!statusEl) return;
      statusEl.textContent = message || "";
      statusEl.classList.toggle("is-error", Boolean(isError));
    };

    const startUpload = async () => {
      if (uploading) return;

      const file = fileInput && fileInput.files && fileInput.files[0];
      if (!file) {
        setStatus("Choose a video file first.", true);
        if (fileInput) fileInput.focus();
        return;
      }
      if (attestation && !attestation.checked) {
        setStatus("Please confirm you are 18 or over and hold the rights to this video.", true);
        attestation.focus();
        return;
      }

      uploading = true;
      if (startBtn) startBtn.disabled = true;
      if (fileInput) fileInput.disabled = true;
      if (progressEl) {
        progressEl.hidden = false;
        progressEl.value = 0;
      }
      setStatus("Uploading video...");

      try {
        const signedId = await uploadFile(file, uploadUrl, (percent) => {
          if (progressEl) progressEl.value = percent;
          setStatus(`Uploading video... ${percent}%`);
        });

        videoField.value = signedId;
        setStatus("Saving video...");
        form.requestSubmit();
      } catch (error) {
        uploading = false;
        if (startBtn) startBtn.disabled = false;
        if (fileInput) fileInput.disabled = false;
        if (progressEl) progressEl.hidden = true;
        setStatus(error.message || "The upload failed. Please try again.", true);
      }
    };

    if (startBtn) startBtn.addEventListener("click", startUpload);
  });
};

document.addEventListener("DOMContentLoaded", initClipUploads);
document.addEventListener("turbo:load", initClipUploads);
